export const menuList = [
  {
    header: "REPORTS",
    submenu: [
      {
        name: "Generate Reports",
        url: "/generate-reports",
        access: "REPORTS",
      },
      {
        name: "Transactions",
        url: "/transactions",
        access: "REPORTS",
      }
    ],
  },
  {
    header: "SETTINGS",
    submenu: [
      {
        name: "Admin Panel",
        url: "/admin-panel",
        access: "ADMIN_PANEL",
      },
      {
        name: "Bank Codes",
        url: "/bank-codes",
        access: "BANKLIST",
      },
      {
        name: "Generate Order",
        url: "/generate-order",
        access: "GENERATE_ORDER",
      },
      {
        name: "User Management",
        url: "/user-management",
        access: "USER_MANAGEMENT",
      },
      {
        name: "Merchants",
        url: "/merchants",
        access: "MERCHANTS",
      },
      {
        name: "MIDs",
        url: "/mids",
        access: "MIDS",
      },
      {
        name: "My Account",
        url: "/my-account",
        access: "MY_ACCOUNT",
      },
      {
        name: "Cascading",
        url: "/provider-priority",
        access: "CASCADING",
      },
      {
        name: "Providers",
        url: "/providers",
        access: "PROVIDERS",
      },
      {
        name: "Currency Table",
        url: "/currency-table",
        access: "CURRENCY_TABLE",
      }
    ],
  },
  {
    header: "RISK MANAGEMENT",
    submenu: [
      {
        name: "Blacklist",
        url: "/blacklist",
        access: "BLACKLIST"
      }
    ],
  }/*,
  {
    header: "PAYOUTS",
    submenu: [
      {
        name: 'Import Payouts',
        url: '/import-payouts',
        access: "PAYOUT_EXCEL_UPLOAD",
        permission: true,
      }
    ],
  }*/
];
